/** Row metrics for dropdown options, shared so menus and autocompletes list at the same size. */
export const DROPDOWN_OPTION_SX = {
  fontSize: "12px",
  lineHeight: "18px",
  minHeight: "34px",
};

/**
 * `slotProps` for an Autocomplete whose options should list at `DROPDOWN_OPTION_SX`. Ready-made
 * rather than left to callers so the option selector can't be mistyped into a silent no-op.
 */
export const dropdownSlotProps = {
  listbox: { sx: { "& .MuiAutocomplete-option": DROPDOWN_OPTION_SX } },
};
